import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M13.5 3.5H2.5C1.94772 3.5 1.5 3.94772 1.5 4.5V11.5C1.5 12.0523 1.94772 12.5 2.5 12.5H13.5C14.0523 12.5 14.5 12.0523 14.5 11.5V4.5C14.5 3.94772 14.0523 3.5 13.5 3.5Z"
            fill="#F9EAA9"
            stroke="#A37D26"
        />
        <path
            d="M3.63281 9.53907H4.79688V10.4063C4.79688 10.6172 4.9375 10.7617 5.14062 10.7617C5.34375 10.7617 5.48438 10.6172 5.48438 10.4063V9.53907H6.64844C6.78516 9.53907 6.875 9.43751 6.875 9.30469C6.875 9.17188 6.78516 9.07032 6.64844 9.07032H5.48438V8.44532H6.64844C6.78516 8.44532 6.875 8.34376 6.875 8.21094C6.875 8.07813 6.78516 7.97657 6.64844 7.97657H5.71484L7 6.00001C7.05078 5.91798 7.07031 5.85157 7.07031 5.77344C7.07031 5.59766 6.92188 5.46485 6.72656 5.46485C6.59766 5.46485 6.49219 5.51954 6.42188 5.64454L5.15234 7.72266H5.12891L3.71093 5.64453C3.64062 5.51953 3.53515 5.46484 3.40625 5.46484C3.21093 5.46484 3.0625 5.59766 3.0625 5.77344C3.0625 5.85156 3.08203 5.91797 3.13281 6L4.56641 7.97657H3.63281C3.49609 7.97657 3.40625 8.07813 3.40625 8.21094C3.40625 8.34376 3.49609 8.44532 3.63281 8.44532H4.79688V9.07032H3.63281C3.49609 9.07032 3.40625 9.17188 3.40625 9.30469C3.40625 9.43751 3.49609 9.53907 3.63281 9.53907Z"
            fill="#6E4D15"
        />
        <path
            d="M8.5 3.5V6.5M8.5 12V9.5M8.5 9.5H14.5M8.5 9.5V6.5M8.5 6.5H14.5"
            stroke="#A37D26"
            strokeWidth="0.75"
        />
    </svg>
);

export default Icon;
